module.exports = __webpack_public_path__ + "assets/media/potential.77a4e66e.mp3";